import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const Campaign = {
  Helmet: lazy(() => import('./components/CampaignHelmet')),
  Overview: {
    Component: lazy(() => import('./scenes/Overview')),
    Providers: lazy(() => import('./scenes/Overview/Providers')),
  },
  Edit: lazyNamed(() => import('./scenes/BookingTool/containers/CampaignEdit'), 'CampaignEdit'),
  DocumentPreview: lazy(() => import('./scenes/BookingTool/containers/CampaignPreview')),
  EditPositions: lazy(() => import('./scenes/BookingTool/containers/CampaignPositionsEdit')),
  History: lazy(() => import('./scenes/History')),
  PaymentDetails: {
    Component: lazy(() => import('./scenes/PaymentDetails')),
    Providers: lazy(() => import('./scenes/PaymentDetails/Providers')),
  },
  FiltersProvider: lazy(() => import('src/modules/CampaignFilters/RouteLayout')),
  EditPermissionChecker: lazyNamed(() => import('./components/EditPermissionChecker'), 'EditPermissionChecker'),
};

export default Campaign;
